import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { FlagIcon, Heart2Icon } from "../assets/icons";
import { capitalizeSentence, formatCharacterName } from "../Utils/formatReportText";

const indicatorStatuses = {
  KONSISTEN: { label: "Konsisten Muncul", color: "#48B920", style: "consistent" },
  SERING: { label: "Sering Muncul", color: "#48B920", style: "consistent" },
  KADANG: { label: "Kadang Muncul", color: "#F39A00", style: "sometimes" },
  BELUM: { label: "Belum Muncul", color: "#D84343", style: "missing" },
  BELUMMUNCUL: { label: "Belum Muncul", color: "#D84343", style: "missing" },
};

export default function ReportIndicatorItem({ item, characterName, compact = false, isLast = false }) {
  const apiLabel = item.label?.toUpperCase().replace(/[\s_-]/g, "");
  const status = indicatorStatuses[apiLabel] || {
    label: item.label || `Nilai ${item.value}`,
    color: "#666666",
    style: "neutral",
  };
  if (compact) {
    return (
      <View style={[styles.compactRow, isLast && styles.lastRow]}>
        <View style={styles.chipRow}>
          <View style={styles.indicatorChip}>
            <Heart2Icon customColor="#9A9A9A" />
            <Text style={styles.chipText}>{characterName ? formatCharacterName(characterName) : "Indikator"}</Text>
          </View>
          <View style={[styles.statusChip, styles[status.style]]}>
            <FlagIcon width={13} height={13} customColor={status.color} />
            <Text style={[styles.statusText, { color: status.color }]}>{status.label}</Text>
          </View>
        </View>
        <Text style={styles.compactName}>{capitalizeSentence(item.name)}</Text>
      </View>
    );
  }

  return (
    <View style={[styles.row, isLast && styles.lastRow]}>
      <Text style={styles.name}>{capitalizeSentence(item.name)}</Text>
      <View style={[styles.statusPill, styles[status.style]]}>
        <FlagIcon width={13} height={13} customColor={status.color} />
        <Text style={[styles.statusText, { color: status.color }]}>{status.label}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  row: { paddingVertical: 11, borderBottomWidth: StyleSheet.hairlineWidth, borderBottomColor: "#EAEAEA", borderStyle: "dashed" },
  compactRow: { paddingVertical: 10, borderBottomWidth: StyleSheet.hairlineWidth, borderBottomColor: "#EEEEEE" },
  lastRow: { borderBottomWidth: 0 },
  name: { color: "#191919", fontFamily: "Archivo-Regular", fontSize: 11, lineHeight: 16 },
  compactName: { marginTop: 8, marginLeft: 2, color: "#1F1F1F", fontFamily: "Archivo-Regular", fontSize: 11, lineHeight: 16 },
  chipRow: { flexDirection: "row", alignItems: "center", flexWrap: "wrap", gap: 6 },
  indicatorChip: { minHeight: 24, paddingHorizontal: 8, borderRadius: 6, backgroundColor: "#F1F1F1", flexDirection: "row", alignItems: "center", gap: 6 },
  chipText: { color: "#555555", fontFamily: "Archivo-Regular", fontSize: 10 },
  statusChip: { minHeight: 24, paddingHorizontal: 8, borderRadius: 5, flexDirection: "row", alignItems: "center", gap: 5 },
  statusPill: { minHeight: 22, alignSelf: "flex-start", marginTop: 7, paddingHorizontal: 8, borderRadius: 5, flexDirection: "row", alignItems: "center", gap: 5 },
  statusText: { fontFamily: "Archivo-Regular", fontSize: 10 },
  consistent: { backgroundColor: "#DDF3D5" },
  sometimes: { backgroundColor: "#FFF0C8" },
  missing: { backgroundColor: "#FFE0E0" },
  neutral: { backgroundColor: "#F1F1F1" },
});